import { all, fork } from 'redux-saga/effects';
import auth from './authSaga';
import user from './userSaga';
import form from './formSaga';
import dashboard from './dashboardSaga';
export default function* rootSaga() {
  yield all([fork(auth), fork(user), fork(form), fork(dashboard)]);
}
